module.exports = __webpack_public_path__ + "static/media/closed-eye.14d6e5eb.svg";